import form from "./schemas/form";
import validations from "./schemas/validations";
import {useState} from "react";
import axios from "axios";
import {API_URL} from "../../../config";

const useNewTable = () => {

    const {formId, formField} = form;
    const currentValidation = validations;

    const [isLoading, setIsLoading] = useState(false);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    const handleSubmit = async (values, actions) => {

        try {

            // Enviar datos a API
            await axios.post(
                `${API_URL}/tables`,
                {...values}
            );

            actions.resetForm();

            setSnackbarConfig({
                message: 'Table saved successfully',
                icon: 'notifications',
                title: 'Tables',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Tables',
                color: 'warning'
            });

            setShow(true);

        }

        actions.setSubmitting(false);

    };

    return {
        currentValidation,
        formId,
        formField,
        isLoading,
        show,
        snackbarConfig,
        handleSubmit,
        toggleSnackbar
    };
};

export default useNewTable;
